<template>
  <iframe v-if="!id" class="mt-3 mb-5" style="width:100%;height:100vh;" src="/submit.php"></iframe>
  <iframe v-else class="mt-3 mb-5" style="width:100%;height:100vh;" :src="'/submit.php?id=' + id"></iframe>
</template>
<script>
   export default {
    mounted: function() {

    },
    data: () => ({
     infoOptions: {
          pixelOffset: {
            width: 0,
            height: 0
          }
      },
      currentInfoWindow: 'x',
      descriptionDialog: false,
      showProperty: {},
      city: '',
      breakPoint: 900,
    }),

    props: {
      id: String,
    },

    computed: {},

    methods: {}
   }
</script>